import { privateKeyToAccount } from 'viem/accounts'
import { getEnv } from '@/config/env'
import type { Address } from 'viem'

export function getDemoPrivateKey(): Address | null {
  const { demoPrivateKey } = getEnv()
  return demoPrivateKey ?? null
}

export function getDemoWalletAddress(): Address | null {
  const privateKey = getDemoPrivateKey()
  if (!privateKey) {
    return null
  }

  try {
    return privateKeyToAccount(privateKey).address
  } catch {
    return null
  }
}

export function isDemoWalletEnabled(): boolean {
  return Boolean(getDemoPrivateKey())
}
